var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticStyle:{"display":"flex","align-items":"center","justify-content":"center","width":"100%","height":"100%","position":"relative"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }